<template>
  <list-page-layout class="lease-list-page" :pageSize="pageSize" :currentPage="currentPage" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">租赁订单列表</span>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.Product" placeholder="请输入物料名称/物料编码" @keyup.enter.native="handleSearch()"></el-input>
      </el-form-item>
      <el-form-item label="租赁订单">
        <el-input class="form-input" v-model="Search.OrderCode" placeholder="请输入租赁订单编码" @keyup.enter.native="handleSearch()"></el-input>
      </el-form-item>
      <el-form-item label="订单类型">
        <el-select class="form-input" v-model="Search.OrderType" filterable placeholder="请选择租期类型" clearable>
          <el-option label="固定租期" value="inflexibleTerm"></el-option>
          <el-option label="灵活租期" value="flexibleTerm"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户合同编号">
        <el-input class="form-input" v-model="Search.CustomCode" placeholder="请输入合同编号" @keyup.enter.native="handleSearch()"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" @click="handleSearch()" style="width: 120px">查询</el-button>
        <router-link to="/trust">
          <el-button type="primary" style="width: 140px">新建租赁申请单</el-button>
        </router-link>
      </el-form-item>
    </el-form>
    <div class="main-content" slot="main-content">
      <el-tabs v-model="currentTab" @tab-click="handleSearch()">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="待发货" name="notSent"></el-tab-pane>
        <el-tab-pane label="部分发货" name="partlySent"></el-tab-pane>
        <el-tab-pane label="已完成" name="completed"></el-tab-pane>
        <el-tab-pane label="已取消" name="cancelled"></el-tab-pane>
      </el-tabs>
      <complex-grid v-loading="IsLoading" element-loading-text="加载中" :config="tableConfig" :data="tableData">
        <template slot="sub-header" scope="props">
          <el-col :span="24">
            <span>{{props.row.OrderDate | date('YYYY-MM-DD HH:mm:ss')}}</span>
            <span style="margin-left: 20px">租赁订单：{{props.row.Code}}</span>
            <span style="margin-left: 20px">订单类型：{{props.row.OrderType | RentalOrderOrderType}}</span>
            <span style="margin-left: 20px">合同编号：{{props.row.CustomerContractCode}}</span>
            <span style="margin-left: 20px">订单租金：{{props.row.TotalRentalAmount | amount}}{{checkRentalPaid(props.row)}}</span>
            <span style="margin-left: 20px">订单押金：{{getTotalDeposit(props.row) | amount}}{{checkDepositPaid(props.row)}} </span>
            <span style="margin-left: 20px">保修费用：{{props.row.TotalWarrantyAmount | amount}} </span>
          </el-col>
          <el-col :span="4" class="text-right" v-if="props.row.State === 'needConfirmation'">状态：
            <span style="color: red">
              <countdown :date="props.row.OrderDate"></countdown> 后自动确认</span>
          </el-col>
          <el-col :span="4" class="text-right" v-if="props.row.State !== 'needConfirmation'">状态：
            <span style="color: red">{{props.row.State | RentalOrderState}}</span>
          </el-col>
        </template>
        <template slot="ProductName" scope="props">
          <p style="margin: 4px 0">{{props.row.Product.Name}}</p>
          <p style="margin: 4px 0">物料编码：{{props.row.Product.Code}}</p>
        </template>
        <template slot="CustomerProductName" scope="props">
          <p style="margin: 4px 0">{{props.row.CustomerProductName}}</p>
          <p style="margin: 4px 0">物料编码：{{props.row.CustomerProductCode}}</p>
        </template>
        <template slot="ProductConditionName" scope="props">
          <el-tag type="primary">{{props.row.ProductCondition.Name}}</el-tag>
        </template>
        <template slot="RentalPeriod" scope="props">
          {{props.row.RentalPeriod}}个月
        </template>
        <template slot="RentalUnitPrice" scope="props">
          ¥{{props.row.RentalUnitPrice}}
        </template>
        <template slot="action-bar" scope="props">
          <router-link :to="{name: 'LeaseDetail', params: {id: props.row.Id}}">
            <el-button type="primary" size="mini">查看</el-button>
          </router-link>
          <template v-if="props.row.State === 'normal' || props.row.State === 'completed'">
            <el-button type="primary" style="margin-left: 10px;" size="mini" @click="goto({name: 'LeaseDetail', params: {id: props.row.Id}})">售后服务</el-button>
          </template>
        </template>
      </complex-grid>
    </div>
  </list-page-layout>
</template>

<script>
import Countdown from '@/components/common/Countdown'
import ListPageLayout from '@/components/common/ListPageLayout'
import ComplexGrid from '@/components/common/ComplexGrid'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        Product: null,
        OrderCode: null,
        OrderType: null,
        CustomCode: null,
      },
      currentTab: 'all',
      pageSize: 10,
      currentPage: 1,
      tableConfig: {
        dataPrefix: 'ProductLines',
        column: [
          {
            label: '物料名称',
            width: '260px',
            slot: 'ProductName',
          },
          {
            label: '品项',
            width: '140px',
            slot: 'ProductConditionName',
          },
          {
            label: '租赁数量',
            prop: 'RentalQuantity',
          },
          {
            label: '客户物料名称',
            width: '260px',
            slot: 'CustomerProductName',
          },
          {
            label: '租赁周期',
            slot: 'RentalPeriod',
          },
          {
            label: '租金单价',
            slot: 'RentalUnitPrice',
          },
          {
            label: '操作',
            collapse: true,
            key: 'action-bar',
            class: 'text-center',
            width: '180px',
          },
        ],
      },
      tableData: [],
      total: 0,
      IsLoading: false,
    }
  },
  methods: {
    handleSearch() {
      console.log(this.currentPage)
      this.IsLoading = true
      const Query = o('RentalOrder')
      let filters = []
      Query.expand('Partner($select=Name)')
      Query.expand('ProductLines($expand=Product,ProductCondition)')
      if (this.currentTab !== 'all') {
        filters.push(`contains(State, '${this.currentTab}')`)
      }
      // 已完成订单包含租赁中的订单
      if (this.currentTab === 'completed') {
        filters.push(`
        contains(State, '${this.currentTab}')
          or
        contains(State, 'normal')`)
      }
      if (this.Search.OrderCode) {
        filters.push(`contains(Code, '${this.Search.OrderCode}')`)
      }
      if (this.Search.OrderType) {
        filters.push(`OrderType eq '${this.Search.OrderType}'`)
      }
      if (this.Search.CustomCode) {
        filters.push(`contains(CustomerContractCode, '${this.Search.CustomCode}')`)
      }
      if (this.Search.Product) {
        filters.push(`(
          ProductLines/any(p:contains(p/Product/Name, '${this.Search.Product}'))
          or
          ProductLines/any(p:contains(p/Product/Code, '${this.Search.Product}'))
        )`)
      }
      if (filters.length > 0) {
        Query.filter(filters.join(' and '))
      }
      Query.inlineCount()
      Query.skip((this.currentPage - 1) * this.pageSize)
      Query.top(this.pageSize)
      Query.orderBy('OrderDate', 'desc')
      Query.get().then(({ data, inlinecount }) => {
        this.IsLoading = false
        this.tableData = data
        this.total = inlinecount
      }).fail((error) => {
        this.IsLoading = false
        this.$alert(error.message)
      })
    },
    handleChange(params) {
      this.currentPage = params
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    goto(data) {
      this.$router.push(data)
    },
    checkDepositPaid(item) {
      return item.IsDepositPaid ? '（已付）' : '（未付）'
    },
    checkRentalPaid(item) {
      return item.IsPaid ? '（已付）' : '（未付）'
    },
    getTotalDeposit(item) {
      var deposit = 0
      item.ProductLines.forEach(function(row) {
        deposit += row.Deposit
      }, this)
      return deposit
    },
  },
  components: {
    ListPageLayout,
    ComplexGrid,
    Countdown,
  },
  created() {
    console.log(this.$route.query)
    this.handleSearch()
  },
}
</script>

<style lang="less" scoped>
.form-input {
  width: 260px;
}
</style>

<style lang="less">
.lease-list-page .el-tabs__active-bar{
  display: none;
}
</style>




// WEBPACK FOOTER //
// LeaseListPage.vue?49085b35